import React, {PropTypes, Component} from 'react';
import {I18N, CONFIG} from '../../../globals/config';

const api = CONFIG.api + 'subscriptions/';

class PartThree extends Component {
	constructor( props ){
		super( props );

		_.bindAll( PartThree, 'onChange', '_save_settings' );
	}


	static onChange( event ){
		let $unsubscribe = event.target.checked ? 0 : 1;
		PartThree._save_settings( event.target, $unsubscribe );

	}

	static _save_settings( sub, $un_subscribe ){
		let data = $( sub ).data();
		if( $un_subscribe ){
			data.method = 'unsubscribe';
		} else {
			data.method = 'subscribe';
		}

		$.post( api, data, function(){
		} );

	}

	render(){
		let header = "";
		if( !this.props.open_with_login ){
			header = (
				<header>
					<h6>
						{I18N.subscriptions.success}
					</h6>
					<h4>
						<i className="fa fa-check-circle"/>
						{this.props.subscription.title}
					</h4>
					<p>
						{I18N.subscriptions.would_like}
					</p>
				</header>
			);
		}
		return (
			<div className="form-wrap">
				{header}
				<ul>
					{CONFIG.featured_subscriptions.map( function( sub, $index ){
						return (
							<li key={'featured-sub-' + $index}>
								<input type="checkbox" data-id={sub.id} data-type={sub.type} data-format={sub.format} data-blog_id={sub.blog_id} value="1" onClick={PartThree.onChange}/>
								<label htmlFor="daily">
									{sub.title}
								</label>
							</li>
						)
					}.bind( this ) )}
				</ul>

				<p>
					<a href={CONFIG.subscriptions_url}>
						{I18N.subscriptions.view_all} <i className="fa fa-long-arrow-right"/>
					</a>
				</p>

				<a className="button button-primary" href={CONFIG.dashboard_url}>
					{I18N.subscriptions.go_to}
				</a>
			</div>
		)
	}
}

PartThree.propTypes = {
	changeStep : PropTypes.func.isRequired,
	first_name : PropTypes.string.isRequired,
};

export default PartThree;


// WEBPACK FOOTER //
// ./src/components/modals/join/part-three.js